var _filter, _filter2, _filter3, _path, _path2, _path3, _path4, _line, _line2, _line3, _path5, _path6, _path7, _path8, _polygon, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElysiumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ethNotebookGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#7C3AED",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#6D28D9",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#312E81",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ethShadowGradient",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ethPageGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#EDE9FE",
      stopOpacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#C7D2FE",
      stopOpacity: 0.35
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ethHighlightGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#A5B4FC",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "ethGlow",
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "glowBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7C3AED",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "glowBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "ethBevel",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2,
    result: "bevelBlur"
  }), /*#__PURE__*/React.createElement("feSpecularLighting", {
    surfaceScale: 6,
    specularConstant: 1.2,
    specularExponent: 15,
    lightingColor: "#FFFFFF",
    in: "bevelBlur",
    result: "specOut"
  }, /*#__PURE__*/React.createElement("fePointLight", {
    x: -600,
    y: -600,
    z: 250
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "specOut",
    in2: "SourceAlpha",
    result: "specOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "arithmetic",
    k1: 0,
    k2: 1,
    k3: 1.2,
    k4: 0,
    in: "specOut",
    in2: "SourceGraphic"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "innerDepth",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "depthBlur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "offsetBlur",
    in2: "SourceAlpha",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0 L100 50 L50 100 L0 50 Z",
    fill: "url(#ethNotebookGradient)",
    filter: "url(#ethGlow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10 L90 50 L50 90 L10 50 Z",
    fill: "url(#ethShadowGradient)",
    opacity: 0.55,
    filter: "url(#ethBevel)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20 L80 50 L50 80 L20 50 Z",
    fill: "url(#ethPageGradient)",
    opacity: 0.85,
    filter: "url(#innerDepth)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25 L75 50 L50 75 L25 50 Z",
    fill: "#FFFFFF",
    opacity: 0.92
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    stroke: "#E0E7FF",
    strokeWidth: 3,
    strokeOpacity: 0.65
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 20,
    x2: 45,
    y2: 80,
    stroke: "#D1D5DB",
    strokeWidth: 1.5,
    strokeOpacity: 0.85
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 20,
    x2: 55,
    y2: 80,
    stroke: "#D1D5DB",
    strokeWidth: 1.5,
    strokeOpacity: 0.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0 L100 50 L90 50 L50 10 Z",
    fill: "url(#ethHighlightGradient)",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100 L100 50 L90 50 L50 90 Z",
    fill: "#818CF8",
    opacity: 0.45
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0 L0 50 L10 50 L50 10 Z",
    fill: "url(#ethHighlightGradient)",
    opacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100 L0 50 L10 50 L50 90 Z",
    fill: "#818CF8",
    opacity: 0.45
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,15 85,50 50,85 15,50",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 6,
    fill: "#FFFFFF",
    opacity: 0.3,
    filter: "url(#ethBevel)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElysiumLogo);
export default __webpack_public_path__ + "static/media/ElysiumLogo.f6d1c818acebbdad74875700d1f49b10.svg";
export { ForwardRef as ReactComponent };